import { ViewNameTranslation } from "~/hooks/useNavbar";

import { WorkstationSettingsView } from "./WorkstationSettingsView";

type Props = {
  viewTitle: ViewNameTranslation;
};

export function SettingsWorkstationPage({ viewTitle }: Props) {
  return <WorkstationSettingsView viewTitle={viewTitle} />;
}
